import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "fs-6 fw-bold" }
const _hoisted_2 = {
  key: 0,
  class: "mt-4 p-3 text-center text-gray"
}
const _hoisted_3 = {
  key: 1,
  class: "d-flex mt-4"
}
const _hoisted_4 = { class: "col p-0" }
const _hoisted_5 = { class: "d-flex" }
const _hoisted_6 = { class: "" }
const _hoisted_7 = {
  "data-v-cdc1d34a": "",
  class: "text-h4"
}
const _hoisted_8 = { class: "ps-3" }
const _hoisted_9 = {
  "data-v-cdc1d34a": "",
  class: "text-h4"
}
const _hoisted_10 = {
  "data-v-cdc1d34a": "",
  class: "text-caption"
}
const _hoisted_11 = { class: "table table-borderless w-100 mt-5 mb-0" }
const _hoisted_12 = {
  class: "fw-bold py-1 px-0",
  style: {"width":"7.6em"}
}
const _hoisted_13 = { class: "py-1 px-0" }
const _hoisted_14 = ["aria-valuenow"]
const _hoisted_15 = { class: "v-progress-linear__content justify-content-end" }
const _hoisted_16 = { class: "ms-3 d-flex flex-column justify-space-between" }
const _hoisted_17 = { class: "p-2 rounded-3 bg-warning-darken-1 text-white" }
const _hoisted_18 = { key: 0 }

import { ref } from 'vue'
import { useRouter } from 'vue-router'
import UserGoal from '../../../api/v2/models/user_goal'
import { UserExamDetail } from '../../../api/v2/models/user_exam'
import api from '../../../api/v2/api'
import ExamEvaluationComponent from './ExamEvaluation.vue'
import { ROUTER_NAME } from '../../router'


export default /*@__PURE__*/_defineComponent({
  __name: 'UserGoalUserExam',
  props: {
    userGoal: {},
    userExamId: {}
  },
  setup(__props: any) {

const router = useRouter()

// Props
const props = __props

// Reactive Data
const userExam = ref<UserExamDetail | null>(null)

// Functions
function gotoExamResult() {
  if (!userExam.value) return
  router.push({
    name: ROUTER_NAME.EXAM_RESULT,
    params: {
      examId: `${userExam.value.examId}`
    },
    query: {
      user_exam_id: `${userExam.value.id}`
    }
  })
}

// Created logic
;(async () => {
  userExam.value = await api.userExam.show(props.userExamId)
})()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h3", _hoisted_1, _toDisplayString(userExam.value?.examName), 1 /* TEXT */),
    (userExam.value && userExam.value.examHideResult)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, " 結果公開待ち "))
      : _createCommentVNode("v-if", true),
    (userExam.value && !userExam.value.examHideResult)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, _toDisplayString(userExam.value.average), 1 /* TEXT */),
                _cache[0] || (_cache[0] = _createElementVNode("span", {
                  "data-v-cdc1d34a": "",
                  class: "text-caption"
                }, "%", -1 /* CACHED */)),
                _cache[1] || (_cache[1] = _createElementVNode("p", { class: "col-12 p-0 m-0 text-caption" }, "スコア", -1 /* CACHED */))
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, _toDisplayString(userExam.value.position), 1 /* TEXT */),
                _createElementVNode("span", _hoisted_10, "位（" + _toDisplayString(userExam.value.userExamsCount) + "人中）", 1 /* TEXT */),
                _cache[2] || (_cache[2] = _createElementVNode("p", { class: "col-12 p-0 m-0 text-caption" }, "ランキング", -1 /* CACHED */))
              ])
            ]),
            _createElementVNode("table", _hoisted_11, [
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userExam.value.examSkills, (skill, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: index,
                    class: "text-caption"
                  }, [
                    _createElementVNode("th", _hoisted_12, _toDisplayString(skill.name), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_13, [
                      _createElementVNode("div", {
                        role: "progressbar",
                        "aria-valuemin": "0",
                        "aria-valuemax": "100",
                        "aria-valuenow": skill.getSkillScore(userExam.value),
                        class: "v-progress-linear theme--light",
                        style: {"height":"15px"}
                      }, [
                        _createElementVNode("div", {
                          class: "v-progress-linear__background primary",
                          style: _normalizeStyle({opacity: 0.3, left: `${skill.getSkillScore(userExam.value)}%`, width: `${100 - skill.getSkillScore(userExam.value)}%`})
                        }, null, 4 /* STYLE */),
                        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "v-progress-linear__buffer" }, null, -1 /* CACHED */)),
                        _createElementVNode("div", {
                          class: "v-progress-linear__determinate primary",
                          style: _normalizeStyle({width: `${skill.getSkillScore(userExam.value)}%`})
                        }, null, 4 /* STYLE */),
                        _createElementVNode("div", _hoisted_15, _toDisplayString(skill.getSkillScore(userExam.value)) + "% ", 1 /* TEXT */)
                      ], 8 /* PROPS */, _hoisted_14)
                    ])
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ])
          ]),
          _createCommentVNode(" "),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createCommentVNode(" <div class=\"d-flex align-items-end justify-content-center\">\n            <span class=\"text-h4\">87</span>\n            <span class=\"small\">%</span>\n          </div> "),
              (userExam.value.useExamEvaluation && userExam.value.examEvaluations.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _createVNode(ExamEvaluationComponent, {
                      examEvaluations: userExam.value.examEvaluations,
                      score: userExam.value.average
                    }, null, 8 /* PROPS */, ["examEvaluations", "score"])
                  ]))
                : _createCommentVNode("v-if", true),
              _cache[4] || (_cache[4] = _createElementVNode("p", { class: "text-caption text-center mb-0" }, " 予想合格率 ", -1 /* CACHED */))
            ]),
            _createElementVNode("div", { class: "text-end" }, [
              _createElementVNode("a", {
                onClick: gotoExamResult,
                class: "small text-decoration-none"
              }, "詳細")
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})